import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WaterTribeFestTicketSelection } from '../components/WaterTribeFestTicketSelection';
import { WaterTribeFestPrePaymentForm } from '../components/WaterTribeFestPrePaymentForm';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Waves, Heart, GraduationCap, Target, Sparkles, Music, Zap, Users, Calendar, MapPin, CheckCircle2, Flame, MessageCircle, CreditCard, Lock, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { generateOrderNumber } from '../utils/orderNumber';
import { openTranzilaPayment } from '../utils/tranzila';
import { getUtmParams } from '../utils/utmTracking';
const activities = [{
  icon: Waves,
  title: 'חתירות חוויתיות ותחרותיות',
  description: 'מקצים עממיים ותחרותיים לכל הרמות בסאפ, רייס, קיאק וסרפסקי.',
  image: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
}, {
  icon: Heart,
  title: 'חוויות גוף-נפש',
  description: 'יוגה, פילאטיס מחזק ואמבטיית קרח מודרכת להתאוששות',
  image: 'https://cdn.magicpatterns.com/uploads/oRhKrcQ2puhfgDX5hZr1xf/IMG-20250513-WA0010.jpg'
}, {
  icon: GraduationCap,
  title: 'סדנאות חתירה',
  description: 'שיפור טכניקה, הרצאות והדרכות עם המאמנים המובילים בארץ',
  image: 'https://cdn.magicpatterns.com/uploads/o9c53mVsS3VW85WhRtdH5V/IMG-20251017-WA0049.jpg'
}, {
  icon: Target,
  title: 'תכני העשרה',
  description: 'הרצאות השראה, סדנאות ועוד מלא הפתעות',
  image: 'https://cdn.magicpatterns.com/uploads/jv9JCKZ7rbuxPY1UBjZSNt/IMG-20251007-WA0003.jpg'
}, {
  icon: Music,
  title: 'מוזיקה ואווירת חוף',
  description: 'וחה מסיבת שקיעה, בירה קרה ואנשים טובים.',
  image: 'https://cdn.magicpatterns.com/uploads/ogPVnt7wGEJk1JMJE6qQr3/IMG-20250919-WA0024.jpg'
}, {
  icon: Users,
  title: 'מפגש קהילתי',
  description: 'כל קהילת המים של ישראל במקום אחד - הזדמנות להכיר ולהתחבר',
  image: 'https://cdn.magicpatterns.com/uploads/jthr15SsJsNm2nReM2yG6L/IMG-20250201-WA0077.jpg'
}, {
  icon: Sparkles,
  title: 'התנסות בציוד חדשני',
  description: 'הזדמנות לנסות את הציוד המתקדם ביותר עם המותגים המובילים בארץ ובעולם',
  image: 'https://cdn.magicpatterns.com/uploads/7Nsyyb3XcL22vTisSrbp26/file_00000000c840720c8d220c7d5f9e2f7f_(1).png'
}];
const audience = ['חותרות וחותרים, אוהבי ספורט וספורט ימי בכל הרמות', 'חותרים מקצועיים שרוצים להתחרות ולהשתפר', 'מתחילים שרוצים לנסות לראשונה ולהתאהב בים', 'חובבי תנועה, בריאות ולייף-סטייל', 'חובבי ים שרוצים חוויה של חופש', 'כל מי שמחפש חוויה ייחודית, מהנה וקהילתית במים וביבשה'];
const reasons = [{
  title: 'האירוע היחיד מסוגו',
  description: 'שילוב נדיר של מקצועיות, חוויה וקהילה ביום אחד מרוכז'
}, {
  title: 'ציוד בלעדי',
  description: 'הזדמנות לנסות כלים וציוד שלא נגישים ביום-יום'
}, {
  title: 'האנשים הנכונים',
  description: 'לפגוש את המדריכים והחותרים שהופכים את עולם המים למה שהוא'
}, {
  title: 'לוקיישן מושלם',
  description: 'חוף מעגן עדן - רצועת החוף היפה והאקסקלוסיבית ביותר בכנרת'
}];
export function WaterTribeFestPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showPrePaymentForm, setShowPrePaymentForm] = useState(false);
  const [selectedTicketName, setSelectedTicketName] = useState('');
  const [showIframe, setShowIframe] = useState(false);
  const [includeCompanion, setIncludeCompanion] = useState(false);
  const [showShimmer, setShowShimmer] = useState(false);
  const [pendingTicket, setPendingTicket] = useState<{
    price: number;
    name: string;
    priceDisplay: string;
    ticketType?: 'festival-only' | 'accommodation' | 'double-alone';
  } | null>(null);
  // ============================================
  // TEST MODE - DELETE THIS SECTION TO REMOVE
  // ============================================
  const [isTestMode, setIsTestMode] = useState(false);
  // ============================================
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    ;
    (window as any).openWaterTribeFestRegistrationForm = () => setIsFormOpen(true);
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    // Check for test mode URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const testModeParam = urlParams.get('test_mode');
    if (testModeParam === 'watertribe2026') {
      setIsTestMode(true);
      localStorage.setItem('test_mode_active', 'true');
      console.log('🧪 TEST MODE ACTIVATED - All prices set to ₪1');
    } else {
      // Check localStorage in case we navigated away and back
      const storedTestMode = localStorage.getItem('test_mode_active');
      if (storedTestMode === 'true') {
        setIsTestMode(true);
        console.log('🧪 TEST MODE ACTIVE (from localStorage)');
      }
    }
    // ============================================
    // Trigger shimmer animation after 0.5 seconds
    const shimmerTimer = setTimeout(() => {
      setShowShimmer(true);
      // Remove shimmer after 1.5 seconds
      setTimeout(() => setShowShimmer(false), 1500);
    }, 500);
    document.title = 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'פסטיבל החתירה השנתי בכנרת. סאפ, קיאקים, יוגה, סדנאות, הופעות וקהילה.');
    const ogTags = [{
      property: 'og:title',
      content: 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל'
    }, {
      property: 'og:description',
      content: '19-21 בנובמבר 2026 | חוף מעגן עדן, כנרת.'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
    }, {
      property: 'og:url',
      content: window.location.href
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  const handleCompanionOnlyPurchase = () => {
    // Direct purchase of companion ticket only - set ticket type to festival-only
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : 275;
    const finalPriceDisplay = isTestMode ? '1' : '275';
    // ============================================
    const companionTicket = {
      price: finalPrice,
      name: 'כרטיס מלווה בלבד',
      priceDisplay: finalPriceDisplay,
      ticketType: 'festival-only' as const
    };
    setSelectedTicketName(companionTicket.name);
    setPendingTicket(companionTicket);
    setShowPrePaymentForm(true);
    // Track Meta Pixel event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: companionTicket.name,
        content_category: 'Festival Ticket',
        value: companionTicket.price,
        currency: 'ILS'
      });
    }
  };
  const handleTicketSelect = (price: number, name: string, priceDisplay: string) => {
    // Store ticket info and open pre-payment form
    // Determine ticket type based on name
    let ticketType: 'festival-only' | 'accommodation' | 'double-alone' = 'accommodation';
    if (name.includes('פסטיבל בלבד')) {
      ticketType = 'festival-only';
    } else if (name.includes('חדר זוגי לבד') || name.includes('לילה של') && (name.includes('לזוג') || name.includes('זוגי'))) {
      // Private couple room — the room is already determined, so skip the
      // shared-room / roommate questions.
      ticketType = 'double-alone';
    }
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : price;
    const finalPriceDisplay = isTestMode ? '1' : priceDisplay;
    // ============================================
    setSelectedTicketName(name);
    setPendingTicket({
      price: finalPrice,
      name,
      priceDisplay: finalPriceDisplay,
      ticketType
    });
    setShowPrePaymentForm(true);
    // Track Meta Pixel event - Ticket Selected
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: name,
        content_category: 'Festival Ticket',
        value: finalPrice,
        currency: 'ILS'
      });
    }
  };
  const handlePrePaymentFormSubmit = async (formData: any) => {
    // Generate unique order number
    const orderNumber = generateOrderNumber();
    // CRITICAL: Capture UTM params NOW, at form submission time
    // This ensures they're stored with the registration data
    // and won't be lost if localStorage is cleared during payment
    const utmParams = getUtmParams();
    console.log('📊 Capturing UTM params at form submission:', utmParams);
    // Map form data to proper format
    const submissionData = {
      name: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      orderNumber: orderNumber,
      ticketType: pendingTicket?.name || '',
      price: pendingTicket?.priceDisplay || '',
      gender: formData.gender === 'male' ? 'זכר' : formData.gender === 'female' ? 'נקבה' : '',
      companionName: formData.companionName || '',
      companionPhone: formData.companionPhone || '',
      companionGender: formData.companionGender === 'male' ? 'זכר' : formData.companionGender === 'female' ? 'נקבה' : '',
      nightChoice: formData.nightChoice === 'thursday' ? 'חמישי' : formData.nightChoice === 'friday' ? 'שישי' : '',
      roomType: formData.roomType === 'double' ? 'זוגי' : formData.roomType === 'triple' ? 'טריפל' : '',
      roommate1: formData.roommate1Name || '',
      roommate2: formData.roommate2Name || '',
      competitiveTrack: formData.competitiveTrack && formData.competitiveTrack.length > 0 ? formData.competitiveTrack.map((t: string) => {
        if (t === 'no') return 'לא';
        if (t === 'sprint') return 'ספרינט';
        if (t === 'technical') return 'טכני';
        if (t === 'longDistance') return 'לונג דיסטנס';
        return t;
      }).join(', ') : 'לא',
      rowingType: formData.rowingType === 'sup' ? 'סאפ' : formData.rowingType === 'race' ? 'רייס' : formData.rowingType === 'surfski' ? 'סרפסקי' : formData.rowingType === 'surfer' ? 'גולש' : formData.rowingType === 'atmosphere' ? 'סופג אווירה' : '',
      clubName: formData.belongsToClub === 'yes' && formData.clubName ? formData.clubName : 'לא שייך למועדון',
      rentBoard: formData.rentBoard === 'yes' ? 'כן' : formData.rentBoard === 'no' ? 'לא' : '',
      whatsappGroup: formData.whatsappGroup ? 'כן' : 'לא',
      type: 'הרשמה Water Tribe Fest',
      source: 'טופס תשלום',
      // CRITICAL: Include UTM params directly in registration data
      // This ensures they survive localStorage clearing in Meta in-app browsers
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      utm_content: utmParams.utm_content,
      utm_term: utmParams.utm_term,
      utm_id: utmParams.utm_id,
      fbclid: utmParams.fbclid
    };
    // Store order details in localStorage for thank you page
    localStorage.setItem('pendingOrder', JSON.stringify({
      orderNumber: orderNumber,
      name: formData.fullName,
      email: formData.email,
      timestamp: Date.now()
    }));
    // Store registration data for Make.com webhook (sent after payment success)
    localStorage.setItem('pendingRegistrationData', JSON.stringify(submissionData));
    console.log('📦 Registration data stored, waiting for payment...');
    // Close the form
    setShowPrePaymentForm(false);
    // Track Meta Pixel event - Initiate Checkout
    if (window.fbq && pendingTicket) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: pendingTicket.name,
        content_category: 'Festival Ticket',
        value: pendingTicket.price,
        currency: 'ILS',
        num_items: 1
      });
    }
    // Show iframe container
    setShowIframe(true);
    // Open Tranzila payment using the utility function
    if (pendingTicket) {
      // Small delay to ensure iframe is rendered
      setTimeout(() => {
        openTranzilaPayment({
          sum: pendingTicket.price,
          contact: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          pdesc: `Water Tribe Fest 2026 - ${pendingTicket.name}`,
          success_url: `${window.location.origin}/tranzila-success`,
          fail_url: `${window.location.origin}/water-tribe-fest`,
          u1: orderNumber,
          u2: pendingTicket.name,
          u3: pendingTicket.priceDisplay
        });
        // Scroll to iframe after submission
        setTimeout(() => {
          iframeRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }, 100);
    }
  };
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-2243" data-mp="sq2ihklu045c">
      <UtmCapture data-id="element-2244" data-mp="nu543ju4p7v7" />
      <Navigation data-id="element-2245" data-mp="nunb9bibx6hw" />

      {/* ============================================ */}
      {/* TEST MODE INDICATOR - DELETE THIS TO REMOVE */}
      {/* ============================================ */}
      {isTestMode && <div className="fixed top-4 left-4 z-50 bg-yellow-500 text-black px-4 py-2 rounded-lg shadow-lg font-bold text-sm flex items-center gap-2" data-id="element-2246" data-mp="xpyn9m2crzly">
          <Zap className="w-4 h-4" data-id="element-2247" data-mp="5345wy0u1gcp" />
          TEST MODE - ₪1
        </div>}
      {/* ============================================ */}

      {/* Hero */}
      <div className="relative h-screen min-h-[600px] overflow-hidden flex items-center justify-center" data-id="element-2248" data-mp="34eika6gul0s9">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/20 to-[#0A5F8F]/90 z-10" data-id="element-2249" data-mp="38fuc8in71y3m" />
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-2250" data-mp="3i803fq5mgbhr">
          <source src="https://cdn.magicpatterns.com/uploads/bHRRxzcgoWuLZVsSMLwyGt/VID-20251224-WA0026.undefined" type="video/mp4" data-id="element-2251" data-mp="3n7d012maowxj" />
        </video>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-20" data-id="element-2252" data-mp="3s4mlk76kcog3" />

        <div className="relative z-30 container mx-auto px-4 text-center text-white" data-id="element-2253" data-mp="36ihce0rcf4">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-2254" data-mp="50yd4e61tcn0">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/30" data-id="element-2255" data-mp="26tmlt31gosa6">
              <Calendar className="w-5 h-5" data-id="element-2256" data-mp="1uilsvj87vo4h" />
              <span className="font-medium" data-id="element-2257" data-mp="1uhkdj2k64fgy">19-21 בנובמבר 2026</span>
              <span className="mx-2" data-id="element-2258" data-mp="1pj93ortvi4yq">|</span>
              <MapPin className="w-5 h-5" data-id="element-2259" data-mp="1pk23f8uezu7d" />
              <span data-id="element-2260" data-mp="1kkfp0w2uo7wz">חוף מעגן עדן, כנרת</span>
            </div>

            <h1 className="text-6xl md:text-8xl font-black mb-4 tracking-tight drop-shadow-lg" data-id="element-2261" data-mp="1km90qpsblibu">
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-white" data-id="element-2262" data-mp="2i7espqrymg4d">
                WATER TRIBE
              </span>
              <span className="block mt-2" data-id="element-2263" data-mp="2898rlbdz9e0k">FEST 2026</span>
            </h1>

            <p className="text-2xl md:text-4xl font-light mb-12 text-blue-100 max-w-3xl mx-auto" data-id="element-2264" data-mp="248f3agwmhx75">
              פסטיבל החתירה השנתי של ישראל
            </p>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5
          }} className="text-center" data-id="element-2265" data-mp="wwenw8803trl">
              <div className="text-white text-xl md:text-2xl font-light mb-3" data-id="element-2266" data-mp="uayjx5sz4l1r">
                לכל הפרטים המשיכו לגלול
              </div>
              <motion.div animate={{
              y: [0, 12, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-white text-4xl" data-id="element-2267" data-mp="kc9ck6ypeizr">
                ↓
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Story */}
      <section className="py-12 bg-white" data-id="element-2268" data-mp="gbyv9y5go65l">
        <div className="container mx-auto px-4" data-id="element-2269" data-mp="1m00m5d47cuv">
          <div className="max-w-4xl mx-auto text-center" data-id="element-2270" data-mp="1nb4e56k8klz">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-[#0A5F8F] mb-8" data-id="element-2271" data-mp="6kba2ezhzlck">
              זה לא עוד אירוע ספורט
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-2272" data-mp="3a4jy95j0h07i">
              זה סופשבוע אחד שמאחד את כל תרבות החתירה בישראל:
              <br data-id="element-2273" data-mp="3t1l22n0twu9v" />
              <span className="font-bold text-gray-900" data-id="element-2274" data-mp="3t11v21cpvqam">
                מים, קהילה, חוויה וגופנפש.
              </span>
            </motion.p>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="py-16 bg-gray-50" data-id="element-2275" data-mp="5or2et2dgw5y">
        <div className="container mx-auto px-4" data-id="element-2276" data-mp="1nfb8j3uo2vn">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-2277" data-mp="1oqpxdyu2v1j">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2278" data-mp="aq6q6svxpgs1">
              מה מחכה לכם בפסטיבל?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-2279" data-mp="1i3fa3bjkwzih">
              הפסטיבל שמאגד את כל מה שאתם אוהבים בים - בסופשבוע אחד
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2280" data-mp="1r32fe8ffipgt">
            {activities.map((activity, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`rounded-3xl shadow-lg hover:shadow-xl transition-all border border-gray-100 overflow-hidden h-full min-h-[300px] relative ${index === activities.length - 1 ? 'col-span-2 md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-2281" data-mp="1w02kag0jlm6c" data-mpi={index}>
                <div className="absolute inset-0" data-id="element-2282" data-mp="fkrhr8jzmutk">
                  <img src={activity.image} alt={activity.title} className={`w-full h-full object-cover ${activity.imagePosition || 'object-center'}`} data-id="element-2283" data-mp="kkdxppr7ap62" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" data-id="element-2284" data-mp="8334389j8l3y" />
                </div>
                <div className="relative z-10 p-8 h-full flex flex-col justify-end" data-id="element-2285" data-mp="336y53h9yjlr">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-2286" data-mp="3uaszgpgiu9zg">
                    {activity.title}
                  </h3>
                  <p className="text-gray-200 text-sm leading-relaxed" data-id="element-2287" data-mp="3q9hh94zz8r1a">
                    {activity.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Who Should Come */}
      <section className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-2288" data-mp="3bk1us17hb7re">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-2289" data-mp="36kp7xggly0ot" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-2290" data-mp="32ilkrukkt7np" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-2291" data-mp="1rf59cka9wagg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-2292" data-mp="1mg2hy2n7u2qy">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-2293" data-mp="1iez39jgwmcrb">
              <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-2294" data-mp="18gjazd654xg8">
                למי הפסטיבל
                <br data-id="element-2295" data-mp="13pkt495i7rav" />
                <span className="text-cyan-300" data-id="element-2296" data-mp="13payu9dfexzd">מתאים?</span>
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-md" data-id="element-2297" data-mp="yq84pjyzic66">
                בין אם אתם חותרים מקצועיים או שמעולם לא עליתם על סאפ - הפסטיבל
                הזה הוא בשבילכם.
              </p>
            </motion.div>

            <div className="space-y-4" data-id="element-2298" data-mp="pp07l587fhdo">
              {audience.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/10" data-id="element-2299" data-mp="kqoywxtnbcx1" data-mpi={index}>
                  <div className="bg-cyan-400 rounded-full p-1 shrink-0" data-id="element-2300" data-mp="3aemrwxspuiq5">
                    <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-2301" data-mp="2doccra3e3t2m" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-2302" data-mp="2in6vyd59rjn9">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Why Miss (FOMO) */}
      <section className="py-24 bg-gradient-to-br from-orange-50 to-rose-50" data-id="element-2303" data-mp="2mmxpupq3efw0">
        <div className="container mx-auto px-4" data-id="element-2304" data-mp="2rgsabvdiuyw5">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-2305" data-mp="1uy4fh8mdfwuc">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-1 rounded-full font-bold mb-4" data-id="element-2306" data-mp="32927iz2ram0b">
              <Flame className="w-5 h-5" data-id="element-2307" data-mp="2xaqxan8ju9hk" />
              <span data-id="element-2308" data-mp="3c0ex1k131036">FOMO ALERT</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6" data-id="element-2309" data-mp="3bz3wdt2xo8ga">
              למה אסור לפספס?
            </h2>
          </motion.div>

          <div className="max-w-5xl mx-auto" data-id="element-2310" data-mp="2japwt8w7542m">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-orange-100" data-id="element-2311" data-mp="2jbhqge68grq9">
              <ul className="space-y-4" data-id="element-2312" data-mp="2o8rf3rlsszd1">
                {reasons.map((reason, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-2313" data-mp="7knk5jw1qs41" data-mpi={index}>
                    <div className="bg-orange-100 rounded-full p-1 shrink-0 mt-1" data-id="element-2314" data-mp="15gcas92dhwp">
                      <CheckCircle2 className="w-5 h-5 text-orange-600" data-id="element-2315" data-mp="17j85swwe59c" />
                    </div>
                    <div data-id="element-2316" data-mp="66m8j01xnnaz">
                      <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-2317" data-mp="tudvqyp0hkr1">
                        {reason.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-2318" data-mp="yrvw40oyqrnf">{reason.description}</p>
                    </div>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Accommodation */}
      <section className="py-24 bg-gradient-to-br from-blue-50 to-cyan-50" data-id="element-2319" data-mp="1csyh0a481vwr">
        <div className="container mx-auto px-4" data-id="element-2320" data-mp="1cqvhmzh6iqfd">
          <div className="max-w-5xl mx-auto" data-id="element-2321" data-mp="1hjycrc1lu7xo">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-2322" data-mp="1hlrm4z3lr69d">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2323" data-mp="3g21seoi0uoll">
                <Calendar className="w-5 h-5" data-id="element-2324" data-mp="3b4jqhi2f99n3" />
                <span data-id="element-2325" data-mp="3b5uthfo1mdd5">לוח זמנים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2326" data-mp="ckjnopxjpxpe">
                מה לו"ז האירוע?
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-2327" data-mp="7p49txzjg1sz">
                שלושה ימים מלאים בפעילויות, חוויות וקהילה
              </p>
            </motion.div>

            <div className="space-y-8 mb-16" data-id="element-2328" data-mp="3u1b5vgeuf4lv">
              {/* Thursday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 shadow-lg border border-blue-100" data-id="element-2329" data-mp="vcvuppz59n5v">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2330" data-mp="12wn3uptiui7l">
                  <Calendar className="w-8 h-8" data-id="element-2331" data-mp="17u6ruhg0u9cq" />
                  יום חמישי, 19.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2332" data-mp="1cvm8lxb61tpb">
                  {[{
                  time: '14:00 - 15:00',
                  activity: 'הגעה, קבלת חדרים והרשמה'
                }, {
                  time: '15:00 - 16:00',
                  activity: 'מקצה ספרינטים'
                }, {
                  time: '16:30 - 18:00',
                  activity: 'חתירת שקיעה'
                }, {
                  time: '20:00 - 21:00',
                  activity: 'הרצאת השראה'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2333" data-mp="20l6x0vq39j5z" data-mpi={index}>
                      <div className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2334" data-mp="25gm9pkcd190t">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2335" data-mp="1atdl8rb4f29s">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Friday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-3xl p-8 shadow-lg border border-cyan-100" data-id="element-2336" data-mp="1yk9mef1gv9tp">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2337" data-mp="e4xy11vhh4zu">
                  <Calendar className="w-8 h-8" data-id="element-2338" data-mp="96e86qdrr927" />
                  יום שישי, 20.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2339" data-mp="2ksy9amkhthgi">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'יוגהלאטיס על סאפ'
                }, {
                  time: '8:00 - 9:00',
                  activity: 'מקצה טכני תחרותי'
                }, {
                  time: '9:00 - 11:00',
                  activity: 'יציאה לשני מסלולי חתירה חוויתיים לבחירה: מסלול מעגלי בדרום הכנרת - כ-10 ק"מ, ירדנית - 3 ק"מ'
                }, {
                  time: '11:00',
                  activity: 'פתיחת מתחם אקספו - הדגמות, התנסויות, מוסיקה ופינוקים'
                }, {
                  time: '11:30 - 13:30',
                  activity: 'סדנת חתירה למתחילים | סדנת טכניקה למתקדמים | סדנת אקרויוגה'
                }, {
                  time: '14:00 - 16:00',
                  activity: 'סדנת תיקונים עם זזיק | מבוא לגלישת ווינג'
                }, {
                  time: '17:00 - 19:00',
                  activity: 'מסיבת חוף עם DJ'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2340" data-mp="2eblc0d3741q4" data-mpi={index}>
                      <div className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2341" data-mp="2aajatqppxfli">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2342" data-mp="20kgiztuc27or">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Saturday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 shadow-lg border border-teal-100" data-id="element-2343" data-mp="1qnlkhay287ah">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2344" data-mp="3bzlm2yydm88w">
                  <Calendar className="w-8 h-8" data-id="element-2345" data-mp="3ji32zq8l0pbw" />
                  יום שבת, 21.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2346" data-mp="3ofcy9minjv7n">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'מתיחות ותרגילי כוח על סאפ'
                }, {
                  time: '7:15',
                  activity: 'מסלול תחרותי Long Distance - 10 ק"מ'
                }, {
                  time: '9:00 - 10:30',
                  activity: 'יציאה למסלול חווייתי'
                }, {
                  time: '11:00',
                  activity: 'מקצה מועדונים - מירוץ שליחים'
                }, {
                  time: '12:30',
                  activity: 'פודיום, נשיקות וחיבוקים'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2347" data-mp="prz1a9f9ngdl" data-mpi={index}>
                      <div className="bg-teal-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2348" data-mp="trzqmp3wlbzf">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2349" data-mp="1pu6u1012oj9u">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-2350" data-mp="1g2avjnv2qr53">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2351" data-mp="s6euw0igf7zm">
                <MapPin className="w-5 h-5" data-id="element-2352" data-mp="x6awxu7lcpcj" />
                <span data-id="element-2353" data-mp="x72vndwhj371">אירוח במקום</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2354" data-mp="2mlhfbjsnbzvo">
                שלושה ימים מלאים? הישארו לישון!
              </h2>
              <p className="text-xl text-gray-600" data-id="element-2355" data-mp="fvx9r4l5bbu8">
                כפר הנופש מעגן מציע אירוח נוח במחירים מיוחדים למשתתפי הפסטיבל
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-blue-100" data-id="element-2356" data-mp="aynmnvl8bc9k">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-2357" data-mp="yku418gjm4cg">
                <div data-id="element-2358" data-mp="ujs6qx66s2d4">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2359" data-mp="ukk164o1ru1t">
                    למה לישון במקום?
                  </h3>
                  <ul className="space-y-4" data-id="element-2360" data-mp="13li4ekqnvxjc">
                    {['תתחילו את הבוקר ישר על החוף', 'לא תפספסו אף רגע מהפסטיבל', 'תיהנו ממסיבת הערב עד הסוף', 'מחירים מיוחדים למשתתפי הפסטיבל', 'חדרים נוחים וממוזגים'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-2361" data-mp="35degbvgqr9en" data-mpi={index}>
                        <div className="bg-blue-100 rounded-full p-1" data-id="element-2362" data-mp="199q7d07w86r4">
                          <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-2363" data-mp="19bku8k2q68xu" />
                        </div>
                        <span className="text-gray-700" data-id="element-2364" data-mp="1eaxfj0dy77yb">{item}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-2xl p-8 text-white text-center" data-id="element-2365" data-mp="1n99cdk5er1z7">
                  <MapPin className="w-12 h-12 mx-auto mb-4" data-id="element-2366" data-mp="1s7jb24qcckpk" />
                  <h4 className="text-2xl font-bold mb-2" data-id="element-2367" data-mp="1x7p5ttrwqnbv">כפר הנופש מעגן</h4>
                  <p className="text-blue-100 mb-6" data-id="element-2368" data-mp="1x5ku4pnrok11">
                    אירוח איכותי במחירים נוחים
                  </p>
                  <div className="space-y-3" data-id="element-2369" data-mp="25zzgtdammwu6">
                    <a href="https://www.maagan.co.il/category/%d7%94%d7%97%d7%93%d7%a8%d7%99%d7%9d/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-2370" data-mp="25yphylvy9kmh">
                      <span className="font-medium" data-id="element-2371" data-mp="2q2n1jr54f5jm">תיאור החדרים</span>
                    </a>
                    <a href="https://www.maagan.co.il/%d7%a9%d7%90%d7%9c%d7%95%d7%aa-%d7%95%d7%aa%d7%a9%d7%95%d7%91%d7%95%d7%aa/uncategorized/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-2372" data-mp="2l2hgittcwhai">
                      <span className="font-medium" data-id="element-2373" data-mp="38sv15z9m3dv2">
                        מידע נוסף על כפר הנופש
                      </span>
                    </a>
                  </div>
                  <p className="text-sm text-blue-200 mt-4" data-id="element-2374" data-mp="2z2jvo8aa4wm2">
                    מספר החדרים מוגבל - הזמינו מוקדם!
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-2375" data-mp="3riulk8uic4s5">
              <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-2376" data-mp="379lbobkqo3wt">
                להרשמה המשיכו לגלול למטה ↓
              </Button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing-section" className="py-24 bg-gradient-to-br from-indigo-50 to-purple-50" data-id="element-2377" data-mp="3uymb59blg4py">
        <div className="container mx-auto px-4" data-id="element-2378" data-mp="3h7rb8mj2oxyi">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-6xl mx-auto" data-id="element-2379" data-mp="3la4e936fqhrl">
            <div className="text-center mb-12" data-id="element-2380" data-mp="hlkipbmpjlg3">
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2381" data-mp="hmc9881g6szi">
                <CreditCard className="w-5 h-5" data-id="element-2382" data-mp="1xcmu0cmity6q" />
                <span data-id="element-2383" data-mp="1xbtvfyxpuezo">רכישת כרטיסים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2384" data-mp="2c1sppqm5h69v">
                מחירי הפסטיבל
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-2385" data-mp="273hgni3oizsp">
                הירשמו עכשיו והבטיחו את מקומכם!
              </p>

              {/* What's Included Section */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 md:p-10 border border-cyan-100 shadow-lg mb-12" data-id="element-2386" data-mp="1ee0qkr3j7uzn">
                <div className="flex items-start gap-4" data-id="element-2387" data-mp="34o3r33hkzb7q">
                  <div className="bg-cyan-500 rounded-full p-3 shrink-0" data-id="element-2388" data-mp="2zrn2k86gyuu4">
                    <Sparkles className="w-6 h-6 text-white" data-id="element-2389" data-mp="36u212jde91s1" />
                  </div>
                  <div data-id="element-2390" data-mp="36wef4lg16rzt">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-2391" data-mp="3bsloypbjsnn1">
                      מה כלול במחיר?
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-2392" data-mp="3gtj2golm4ti7">
                      המחיר כולל השתתפות מלאה ב<strong data-id="element-2393" data-mp="3lpzq7howh5ur">כ-ל</strong> חוויית
                      הפסטיבל – כל הסדנאות, הרצאות, חתירות, טבילה מרעננת
                      באמבטיית קרח, בירה קרה ועוד הפתעות 🎉
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Companion Toggle Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className={`mb-8 rounded-3xl p-6 md:p-8 transition-all shadow-xl ${includeCompanion ? 'bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500' : 'bg-white border-2 border-gray-200'}`} data-id="element-2394" data-mp="2xzvsts2b22c7">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-2395" data-mp="reotyd564j0h">
                <div className={`rounded-2xl p-4 shrink-0 transition-all ${includeCompanion ? 'bg-white/20 backdrop-blur-sm' : 'bg-gradient-to-br from-emerald-50 to-teal-50'}`} data-id="element-2396" data-mp="ng7jpkqgaseu">
                  <Users className={`w-8 h-8 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-2397" data-mp="dggr5olganhe" />
                </div>

                <div className="flex-1" data-id="element-2398" data-mp="8k9t0hzaqga0">
                  <h3 className={`text-2xl md:text-3xl font-black mb-2 leading-tight ${includeCompanion ? 'text-white' : 'text-gray-900'}`} data-id="element-2399" data-mp="3qx5kb6csfiu">
                    באים עם מישהו שלא חותר?
                  </h3>
                  <p className={`text-base md:text-lg mb-5 leading-relaxed font-semibold ${includeCompanion ? 'text-white/90' : 'text-gray-700'}`} data-id="element-2400" data-mp="3qwxx4kod47qk">
                    הוסיפו כרטיס מלווה ותהנו יחד מהאווירה, המסיבות והפינוקים 🎉
                  </p>

                  {/* What's Included - Always show */}
                  <div className={`rounded-2xl p-4 mb-5 border transition-all ${includeCompanion ? 'bg-white/10 backdrop-blur-md border-white/20' : 'bg-gradient-to-br from-emerald-50 to-teal-50 border-emerald-200'}`} data-id="element-2401" data-mp="19ntk2omh43l7">
                    <div className="mb-3" data-id="element-2402" data-mp="zo2oejm6fijj">
                      <div className="flex items-center gap-2 mb-1" data-id="element-2403" data-mp="14np55317rgx3">
                        <Sparkles className={`w-5 h-5 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-2404" data-mp="14luj1le7hirf" />
                        <span className={`font-bold ${includeCompanion ? 'text-white' : 'text-emerald-900'}`} data-id="element-2405" data-mp="pwy8nhooftnn">
                          כלול בכרטיס מלווה:
                        </span>
                      </div>
                      <p className={`text-sm font-semibold pr-7 ${includeCompanion ? 'text-white/90' : 'text-emerald-700'}`} data-id="element-2406" data-mp="lx7er53usxew">
                        כל חוויות הפסטיבל!
                      </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5" data-id="element-2407" data-mp="bz9oyd6cisk6">
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2408" data-mp="3oicf79lylq02">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2409" data-mp="3ki297wy62zl7" />
                        <span data-id="element-2410" data-mp="2b4gur9gijdj">מסיבות ואווירה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2411" data-mp="291gbdaoh7uk">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2412" data-mp="bbkirwajxiga" />
                        <span data-id="element-2413" data-mp="b9px2frghmb5">סדנאות חוויה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2414" data-mp="7a8p9fok4d2t">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2415" data-mp="g32h0cl6x4xk" />
                        <span data-id="element-2416" data-mp="g4vqdzn6u399">הרצאות השראה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2417" data-mp="v0us8sjpf75y">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2418" data-mp="pz5gtbskkrhc" />
                        <span data-id="element-2419" data-mp="xr2beblekhr0">מגוון פינוקים</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2420" data-mp="sshbkda2c033">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2421" data-mp="17hn8tvpcbg8c" />
                        <span data-id="element-2422" data-mp="12oklw6f2j514">וגם...</span>
                      </div>
                    </div>
                    <div className={`mt-3 pt-3 border-t ${includeCompanion ? 'border-white/20' : 'border-emerald-200'}`} data-id="element-2423" data-mp="1gfz8en86pocx">
                      <div className={`flex items-center gap-2 text-xs ${includeCompanion ? 'text-white/70' : 'text-red-500'}`} data-id="element-2424" data-mp="1cevptsyr5e80">
                        <X className="w-3.5 h-3.5 shrink-0" data-id="element-2425" data-mp="1qcu4kzgzjco1" />
                        <span data-id="element-2426" data-mp="1lgmwp1513r3g">ללא סדנאות מקצועיות ומקצי חתירה</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-center gap-4" data-id="element-2427" data-mp="3n7giw79iv6kf">
                    <motion.button whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} onClick={() => setIncludeCompanion(!includeCompanion)} className={`relative overflow-hidden w-full max-w-[280px] px-8 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg ${includeCompanion ? 'bg-white text-emerald-600 shadow-white/30' : 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-emerald-500/40'}`} data-id="element-2428" data-mp="3n9b2ni924smx">
                      {showShimmer && !includeCompanion && <motion.div initial={{
                      x: '-100%'
                    }} animate={{
                      x: '200%'
                    }} transition={{
                      duration: 1.5,
                      ease: 'easeInOut'
                    }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-2429" data-mp="1oxrfy5mapbam" />}
                      <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-2430" data-mp="34coym7e5gi9m">
                        <Users className="w-5 h-5" data-id="element-2431" data-mp="39brzrgr0e4cb" />
                        {includeCompanion ? <>
                            <CheckCircle2 className="w-5 h-5" data-id="element-2432" data-mp="37uckzmgeqmar" />
                            מלווה נוסף
                          </> : 'הוסף מלווה'}
                      </span>
                    </motion.button>

                    <button onClick={handleCompanionOnlyPurchase} className={`font-medium text-sm md:text-base transition-colors ${includeCompanion ? 'text-white/80 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-2433" data-mp="2twxra5j4fscz">
                      רוצים כרטיס מלווה בלבד ב-₪275?
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Premium Rooms Info */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#0A5F8F]/5 to-cyan-50 rounded-3xl p-6 md:p-8 mb-8 shadow-lg border border-cyan-200" data-id="element-2434" data-mp="3cwlgapgr60g1">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-2435" data-mp="1r5wnklodkhad">
                <div className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-4 shrink-0" data-id="element-2436" data-mp="1w4g9im2yxt2q">
                  <Sparkles className="w-8 h-8 text-white" data-id="element-2437" data-mp="203yx5pm6ci99" />
                </div>
                <div className="flex-1" data-id="element-2438" data-mp="254d2v10azg44">
                  <h3 className="text-2xl md:text-3xl font-black text-[#0A5F8F] mb-3" data-id="element-2439" data-mp="255ehffgj2kql">
                    ✨ חדרי פרמיום — לחוויה המושלמת
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-5" data-id="element-2440" data-mp="2f1hfoa89dz89">
                    חדרי הפרמיום ממוקמים{' '}
                    <strong data-id="element-2441" data-mp="2jtj1amrbh2ay">בשורות הראשונות לקו הים</strong> — להתעורר עם נוף
                    ישיר לכנרת!
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2442" data-mp="2nwfd9umcq05x">
                    {['מבנה אבן מעוצב וצמוד קרקע', 'אבזור עשיר ומפנק', 'מרפסת עם נוף לכנרת', 'מיזוג אוויר ומקלחת מפנקת'].map((feature, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-2443" data-mp="2xqfngawhpvli" data-mpi={index}>
                        <div className="bg-cyan-100 rounded-full p-0.5" data-id="element-2444" data-mp="2k48lqjdjfsj8">
                          <CheckCircle2 className="w-4 h-4 text-[#0A5F8F]" data-id="element-2445" data-mp="2f5x7lwg7mvv7" />
                        </div>
                        <span className="text-gray-800 font-medium text-sm" data-id="element-2446" data-mp="2tujqg851q5r6">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-2447" data-mp="1w8cl2w0x49dr">
              {[{
              name: 'חדר פרמיום לזוג - כל הסופ״ש (לאדם)',
              priceDisplay: '1,990',
              price: 1990,
              priceWithCompanionDisplay: '3,730',
              priceWithCompanion: 3730,
              showWithCompanion: true,
              companionParticipant: '1,990',
              companionAddon: '1,740'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - כל הסופ״ש (לאדם)',
              priceDisplay: '1,490',
              price: 1490,
              priceWithCompanionDisplay: '2,730',
              priceWithCompanion: 2730,
              showWithCompanion: true,
              companionParticipant: '1,490',
              companionAddon: '1,240'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - לילה של חמישי (לאדם)',
              priceDisplay: '920',
              price: 920,
              priceWithCompanionDisplay: '920',
              priceWithCompanion: 920,
              showWithCompanion: false,
              companionParticipant: '920',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - לילה של שישי (לאדם)',
              priceDisplay: '980',
              price: 980,
              priceWithCompanionDisplay: '980',
              priceWithCompanion: 980,
              showWithCompanion: false,
              companionParticipant: '980',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום לזוג - לילה של חמישי (לאדם)',
              priceDisplay: '1,150',
              price: 1150,
              priceWithCompanionDisplay: '1,150',
              priceWithCompanion: 1150,
              showWithCompanion: false,
              companionParticipant: '1,150',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום לזוג - לילה של שישי (לאדם)',
              priceDisplay: '1,280',
              price: 1280,
              priceWithCompanionDisplay: '1,280',
              priceWithCompanion: 1280,
              showWithCompanion: false,
              companionParticipant: '1,280',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - כל הסופ״ש (לאדם)',
              priceDisplay: '1,650',
              price: 1650,
              priceWithCompanionDisplay: '1,650',
              priceWithCompanion: 1650,
              showWithCompanion: false,
              companionParticipant: '1,650',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - לילה של חמישי (לאדם)',
              priceDisplay: '1,090',
              price: 1090,
              priceWithCompanionDisplay: '1,090',
              priceWithCompanion: 1090,
              showWithCompanion: false,
              companionParticipant: '1,090',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - לילה של שישי (לאדם)',
              priceDisplay: '1,190',
              price: 1190,
              priceWithCompanionDisplay: '1,190',
              priceWithCompanion: 1190,
              showWithCompanion: false,
              companionParticipant: '1,190',
              companionAddon: '0'
            }, {
              name: 'הרשמה לפסטיבל בלבד',
              priceDisplay: '485',
              price: 485,
              priceWithCompanionDisplay: '760',
              priceWithCompanion: 760,
              showWithCompanion: true,
              companionParticipant: '485',
              companionAddon: '275'
            }].filter(item => !includeCompanion || item.showWithCompanion).map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} whileHover={{
              scale: 1.03,
              y: -5
            }} className={`bg-white rounded-3xl p-6 shadow-lg border transition-all cursor-pointer flex flex-col justify-between h-full relative overflow-hidden group ${selectedTicketName === item.name ? includeCompanion ? 'border-green-500 ring-2 ring-green-500 shadow-xl' : 'border-indigo-500 ring-2 ring-indigo-500 shadow-xl' : includeCompanion ? 'border-green-100 hover:shadow-xl hover:border-green-300' : 'border-indigo-100 hover:shadow-xl hover:border-indigo-300'}`} onClick={() => handleTicketSelect(includeCompanion ? item.priceWithCompanion || item.price : item.price, includeCompanion && item.showWithCompanion ? `${item.name} + כרטיס מלווה` : item.name, includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay)} data-id="element-2448" data-mp="f5bo8nbfj4sg" data-mpi={index}>
                    <div className={`absolute top-0 right-0 w-24 h-24 rounded-bl-full -mr-4 -mt-4 opacity-50 group-hover:scale-110 transition-transform ${includeCompanion ? 'bg-gradient-to-br from-green-100 to-transparent' : 'bg-gradient-to-br from-indigo-100 to-transparent'}`} data-id="element-2449" data-mp="17rjrl5rgm75c" />

                    <div className="relative z-10" data-id="element-2450" data-mp="13s1c4pieqo9w">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight min-h-[3.5rem]" data-id="element-2451" data-mp="ou8u9qpe1nsj">
                        {item.name}
                      </h3>

                      {includeCompanion && item.showWithCompanion && <div className="mb-3" data-id="element-2452" data-mp="pq7odqtw5fen">
                          <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold" data-id="element-2453" data-mp="prirdofiij4p">
                            <Users className="w-4 h-4" data-id="element-2454" data-mp="zmaqiwoqte1l" />+ כרטיס מלווה
                          </span>

                          {/* Price Breakdown */}
                          <div className="mt-3 p-3 bg-green-50 rounded-lg border border-green-100" data-id="element-2455" data-mp="13mmdwh8hpsgr">
                            <div className="text-xs text-gray-600 space-y-1" data-id="element-2456" data-mp="1dn52fpb01x50">
                              <div className="flex justify-between items-center" data-id="element-2457" data-mp="1dl22acg4unmk">
                                <span data-id="element-2458" data-mp="1iedbgk8f3ghn">משתתף:</span>
                                <span className="font-semibold text-gray-900" data-id="element-2459" data-mp="1ncom2x6jdv0x">
                                  ₪{item.companionParticipant}
                                </span>
                              </div>
                              <div className="flex justify-between items-center" data-id="element-2460" data-mp="1wcuxmdiockxg">
                                <span data-id="element-2461" data-mp="3gvf2vim3fxzk">מלווה:</span>
                                <span className="font-semibold text-gray-900" data-id="element-2462" data-mp="3gwyn1kavet6m">
                                  ₪{item.companionAddon}
                                </span>
                              </div>
                              <div className="pt-1 mt-1 border-t border-green-200 flex justify-between items-center font-bold" data-id="element-2463" data-mp="37x360yumw3yo">
                                <span className="text-green-700" data-id="element-2464" data-mp="3givcn8magtj">סה״כ:</span>
                                <span className="text-green-700" data-id="element-2465" data-mp="3ivcwzagqp62">
                                  ₪{item.priceWithCompanionDisplay}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>}

                      <div className="flex flex-col gap-1 mt-auto" data-id="element-2466" data-mp="3lsxh9oivr5ey">
                        <span className={`text-4xl font-black ${includeCompanion ? 'text-green-600' : 'text-indigo-600'}`} data-id="element-2467" data-mp="n6b2mkk2yrt8">
                          ₪
                          {includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay}
                        </span>
                      </div>
                    </div>

                    <div className={`mt-6 pt-4 border-t border-gray-100 flex items-center justify-between text-sm font-medium ${includeCompanion ? 'text-green-600 group-hover:text-green-700' : 'text-indigo-600 group-hover:text-indigo-700'}`} data-id="element-2468" data-mp="si81s83ksxo0">
                      <span data-id="element-2469" data-mp="ii7i2l1sofja">
                        {selectedTicketName === item.name ? 'נבחר' : 'לחצו לתשלום'}
                      </span>
                      <div className={`rounded-full p-1 transition-colors ${selectedTicketName === item.name ? includeCompanion ? 'bg-green-600 text-white' : 'bg-indigo-600 text-white' : includeCompanion ? 'bg-green-50 group-hover:bg-green-100' : 'bg-indigo-50 group-hover:bg-indigo-100'}`} data-id="element-2470" data-mp="9j3zdi6ji25b">
                        <CheckCircle2 className="w-4 h-4" data-id="element-2471" data-mp="23vahl0xupj74" />
                      </div>
                    </div>
                  </motion.div>)}
            </motion.div>

            {/* Iframe Container for Tranzila Payment */}
            <div className={`w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 transition-all duration-500 ${showIframe ? 'opacity-100 max-h-[700px] mt-12' : 'opacity-0 max-h-0 overflow-hidden'}`} data-id="element-2472" data-mp="3ofph4ayfm0pz">
              <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-2473" data-mp="19of17isqq40">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-2474" data-mp="fy1hmnce377h">
                  <Lock className="w-4 h-4" data-id="element-2475" data-mp="b12ly0d2us76" />
                  <span className="text-sm font-medium" data-id="element-2476" data-mp="b2doxxyp7vx8">
                    תשלום מאובטח באמצעות טרנזילה
                  </span>
                </div>
                <div className="text-sm font-bold text-[#0A5F8F]" data-id="element-2477" data-mp="k0pncm5t3y08">
                  {selectedTicketName}
                </div>
              </div>
              <iframe ref={iframeRef} name="tranzila" width="100%" height="600" frameBorder="0" allow="payment" className="w-full" data-id="element-2478" data-mp="2qti0u3srmjxs"></iframe>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-2479" data-mp="2o5xuinvhmk9s">
              <Button size="lg" className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-2480" data-mp="2x8gyjbb0f2xm">
                הרשמה לפסטיבל
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* WhatsApp Group Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 to-emerald-50" data-id="element-2481" data-mp="2j9zdxmgei6jx">
        <div className="container mx-auto px-4" data-id="element-2482" data-mp="1lrz7xru3fuiw">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto text-center" data-id="element-2483" data-mp="1qrbx4j8ftdon">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-600 px-4 py-2 rounded-full font-bold mb-6" data-id="element-2484" data-mp="1eaav1trgpouc">
              <MessageCircle className="w-5 h-5" data-id="element-2485" data-mp="19bzllk52xgcn" />
              <span data-id="element-2486" data-mp="14blcdyrqs0d1">הצטרפו לקהילה</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-2487" data-mp="14d665m68ff9u">
              קבוצת הווטסאפ השקטה של האירוע
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-2488" data-mp="vi89c3zyrid8">
              הצטרפו לקבוצת הווטסאפ השקטה שלנו וקבלו עדכונים ראשונים על הפסטיבל,
              מחירים מיוחדים ופרטים חשובים
            </p>

            <motion.div whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-2489" data-mp="lldcdpjc9q12">
              <Button size="lg" className="bg-[#25D366] hover:bg-[#20BA5A] text-white text-xl px-12 py-8 rounded-full shadow-2xl shadow-green-500/30 inline-flex items-center gap-3" onClick={() => window.open('https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA', '_blank')} data-id="element-2490" data-mp="gkfw5ihw3627">
                <MessageCircle className="w-6 h-6" data-id="element-2491" data-mp="6yocvnp37cuo" />
                הצטרפו לקבוצה
              </Button>
            </motion.div>

            <p className="mt-6 text-sm text-gray-500" data-id="element-2492" data-mp="3p52v3yue28yv">
              קבוצה שקטה - רק עדכונים חשובים מהצוות
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sponsors Section */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-2493" data-mp="lom7omhiv0su">
        <div className="container mx-auto px-4" data-id="element-2494" data-mp="pmtfgru0crrw">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-2495" data-mp="bwpwqauc7g77">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-2496" data-mp="14ku5544am7dl">
              תודה לנותני החסות
            </h3>
            <p className="text-lg text-gray-600" data-id="element-2497" data-mp="19cvp7c7pd2e6">שבזכותם כל זה לא היה קורה!</p>
          </motion.div>

          <div className="flex flex-col items-center justify-center gap-8 max-w-4xl mx-auto" data-id="element-2498" data-mp="1ipkyrwbt3j6t">
            {/* First Row: Focus and Super Boards */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-2499" data-mp="1sgpckspqwy02">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2500" data-mp="1nhm9hdtbt1uq">
                <img src="https://cdn.magicpatterns.com/uploads/c9cqmiETssEvaaWTmgei9g/Screenshot_20260114_100258_Adobe_Acrobat~2.jpg" alt="Focus Hawaii" className="max-h-full max-w-full object-contain" data-id="element-2501" data-mp="19rslsytk4nml" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2502" data-mp="2l77is2lrnfhp">
                <img src="https://cdn.magicpatterns.com/uploads/mv2v6jUXwPZU392ZcXr96e/tempFileForShare_20260114-101156.jpg" alt="Super Boards" className="max-h-full max-w-full object-contain" data-id="element-2503" data-mp="nh0omlly9q3m" />
              </motion.div>
            </div>

            {/* Second Row: Freefull, Yamit, Zazik */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-2504" data-mp="125dklil1f8y4">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2505" data-mp="169cyruiuhvob">
                <img src="https://cdn.magicpatterns.com/uploads/jgUGGBjF8wH9kuTWb95A31/IMG-20240320-WA0021.jpg" alt="Freefull Sea Sports" className="max-h-full max-w-full object-contain" data-id="element-2506" data-mp="35f8knfxazixe" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2507" data-mp="2vow0vpxbbtsb">
                <img src="https://cdn.magicpatterns.com/uploads/2GpMhfwu9CXQAfHdGfWn5v/Screenshot_20260114_101728_Photos~2.jpg" alt="Yamit" className="max-h-full max-w-full object-contain" data-id="element-2508" data-mp="3jcx36h3wedza" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2509" data-mp="230rsuxr9r4mg">
                <img src="https://cdn.magicpatterns.com/uploads/73y5FStqEUKbtd3kEz9SFX/tempFileForShare_20260114-101936.jpg" alt="Zazik" className="max-h-full max-w-full object-contain" data-id="element-2510" data-mp="uieu4929orhj" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2511" data-mp="lh6unno0lklv">
                <img src="https://cdn.magicpatterns.com/uploads/npk7YuYBA3fqzgJiMFKPp9/sk_logo_01.jpg" alt="SK Surf Boards" className="max-h-full max-w-full object-contain" data-id="element-2512" data-mp="148px9te4mwnd" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-2513" data-mp="24hy2c0vc1qq2" />
      <WaterTribeFestTicketSelection isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-2514" data-mp="24ihipd5c471z" />
      <WaterTribeFestPrePaymentForm isOpen={showPrePaymentForm} onClose={() => setShowPrePaymentForm(false)} onSubmit={handlePrePaymentFormSubmit} ticketName={pendingTicket?.name || ''} ticketPrice={pendingTicket?.priceDisplay || ''} ticketType={pendingTicket?.ticketType} data-id="element-2515" data-mp="29gj1dwyum4cx" />
    </div>;
}